import "./Sustainability.module.css";
import Header from "@/reusable_sections/Header";
import Harvesting from "./sections/Harvesting";
import Process from "./sections/Process";
import Partners from "./sections/Partners";
import Certifications from "./sections/Certifications";
import Footer from "@/reusable_sections/Footer";
export default function SustainabilityPage() {
  return <div>
      <Header />
      <Harvesting />
      <Process />
      <Partners />
      <Certifications />
      <Footer />
    </div>;
}